import { PREVIEW_MODAL_DIMENSIONS, openModal } from '../openModal/openModal';
export async function openPreviewPremiumModal(_ref) {
  let {
    serviceType,
    referralInfo,
    wixCodeApi,
    appParams
  } = _ref;
  const modalType = 'preview_premium';
  return openModal({
    appParams,
    wixCodeApi,
    modalType,
    serviceType,
    dimensions: PREVIEW_MODAL_DIMENSIONS,
    referralInfo
  });
}
//# sourceMappingURL=openPreviewPremiumModal.js.map